import React, { useContext } from 'react';
import { QuestionCircleFilled, Tooltip } from '@fx-ui/fine-design';
import Intl from '@fx-ui/intl';
import { I18nPhone } from '@fx-ui/platform-sdk';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';

const Phone = () => {
    const { personaLabel, setPersonaInfo } = useContext(PersonaContext);
    const showPhone = personaLabel?.show_phone;

    if (!showPhone) {
        return null;
    }

    return (
        <PersonaCollectItem
            className="fx-persona-phone"
            title={
                <>
                    <span>{Intl.get('persona.phone')}</span>
                    <Tooltip
                        style={{ maxWidth: 200 }}
                        effect="light"
                        content={Intl.get('person.phone.security.tip')}
                        placement="top"
                    >
                        <QuestionCircleFilled className="help-icon" />
                    </Tooltip>
                </>
            }
        >
            <I18nPhone
                waterMark={Intl.get('account.register.phone.placeholder')}
                phoneValid={true}
                disabled={false}
                height={40}
                onBlur={(value) => {
                    setPersonaInfo({
                        phone: value
                    });
                }}
            />
        </PersonaCollectItem>
    );
};

export default Phone;
